import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Navigation } from "./routes";
import { AuthProvider } from "./context";
import { useSiteConfig } from "./hooks";

export default function App() {
  const { siteConfig, getSiteConfig } = useSiteConfig();

  useEffect(() => {
    getSiteConfig();
  }, []);

  useEffect(() => {
    if (siteConfig?.site_name) document.title = siteConfig.site_name;
  }, [siteConfig]);

  return (
    <AuthProvider>
      <Navigation />

      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
      />
    </AuthProvider>
  );
}
